import { Meta } from '@angular/platform-browser';
import { finalize } from 'rxjs/operators';

import { TranslationService } from './translation/services/translation.service';
import { ThemeService } from './shared/theme/services/theme.service';
import { AppService } from './app.service';

/**
 *
 * Constructor
 *
 * @param appService
 * @param translationService
 * @param themeService
 * @param meta
 */
export function appInitializerFactory(
  appService: AppService,
  translationService: TranslationService,
  themeService: ThemeService,
  meta: Meta,
) {

  return () => new Promise<boolean>((resolve) => {

    const metaTagCustomTheme: HTMLMetaElement = meta.getTag('name=application-custom-theme-assets-dir');
    if (metaTagCustomTheme) {
      themeService.customAssetsDir = metaTagCustomTheme.content;
    }

    themeService.assetsDir = meta.getTag('name=application-theme-assets-dir').content;
    appService.language = meta.getTag('name=application-language').content;

    translationService.loadTranslationsForAllThemes().pipe(
      finalize(() => {
        resolve(true);
      }),
    ).subscribe();
  });
}
